export default "__VITE_ASSET__CdYcdZr___"